exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selectMapGoodsPage .mr40[data-v-46f1a393]{margin-right:40px}", ""]);

// exports
